import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TeacherDetailScreen from "./TeacherDetailScreen";
import { Creators as CreatorsTeacher } from "../../../Models/Reducers/TeacherReducer";

const mapStateToProps = (state, props) => {
  return {
    teacherState: state.teacherState,
    subjectState: state.subjectState,
    weekdayState: state.weekdayState,
    timeframeState: state.timeframeState
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...CreatorsTeacher
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeacherDetailScreen);
